module.exports = __webpack_public_path__ + "static/bbis-commercial-1-min-e17c9a6dc9ae43cd5e6c05068359496e.jpg";